export default "__VITE_ASSET__BdUZ18jj__"